module.exports = __webpack_public_path__ + "static/media/noDisponible.e9b40d05.svg";